var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionIcon32X321(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "monitorGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 4,
    x2: 28,
    y2: 28
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B233FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7B4FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90FF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H26C27.1046 22 28 21.1046 28 20V6C28 4.89543 27.1046 4 26 4Z",
    stroke: "url(#monitorGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H20",
    stroke: "url(#monitorGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22V28",
    stroke: "url(#monitorGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13L15 16C15 16 18 11 20 9",
    stroke: "url(#monitorGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon32X321);
export default __webpack_public_path__ + "static/media/subscriptionIcon-32x32-1.a33c1ff3945d55537c8e007b98419137.svg";
export { ForwardRef as ReactComponent };